var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xrd-sub-view-wrapper",attrs:{"data-test":"settings-tab-view"}},[_c('v-container',{staticClass:"xrd-view-common mt-7"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }